import type { ReactNode } from 'react';

export const symbol_square_circle: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M336-306h288q12.75 0 21.38-8.63Q654-323.25 654-336v-288q0-12.75-8.62-21.38Q636.75-654 624-654H336q-12.75 0-21.37 8.62Q306-636.75 306-624v288q0 12.75 8.63 21.37Q323.25-306 336-306Zm30-60v-228h228v228H366Zm-42 254.5Q251-143 197-197t-85.5-127Q80-397 80-480t31.5-156Q143-709 197-763t127-85.5Q397-880 480-880t156 31.5Q709-817 763-763t85.5 127Q880-563 880-480t-31.5 156Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5ZM479.51-140q141.52 0 241-99Q820-338 820-479.51q0-141.52-99.49-241-99.48-99.49-241-99.49Q338-820 239-720.51q-99 99.48-99 241Q140-338 239-239t240.51 99Zm.49-340Z"
		/>
	</svg>
);
